function Background(props) {
  return <div>{props.children}</div>
}

export default Background
